<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>资产加速折旧、摊销(扣除)优惠明细表</dt>
    </dl>

    <div class="tax-table-body">
      <table class="">
        <tbody>
          <tr>
            <td rowspan="3" class="td-center" style="width: 50px">行次</td>
            <td colspan="5" rowspan="3" class="td-center">项目</td>
            <td colspan="2" rowspan="2" class="td-center" style="width: 120px">年享受优惠的资产原值</td>
            <td colspan="10" class="td-center">本年累计折旧摊销（扣除）金额</td>
          </tr>
          <tr>
            <td colspan="2" class="td-center" style="width: 120px">账载折旧摊销金额</td>
            <td colspan="2" class="td-center" style="width: 120px">按照税收一般规定计算的折旧摊销金额</td>
            <td colspan="2" class="td-center" style="width: 120px">享受加速政策计算的折旧摊销金额</td>
            <td colspan="2" class="td-center" style="width: 120px">纳税调减金额</td>
            <td colspan="2" class="td-center" style="width: 120px">享受加速政策优惠金额</td>
          </tr>
          <tr>
            <td colspan="2" class="td-center">1</td>
            <td colspan="2" class="td-center">2</td>
            <td colspan="2" class="td-center">3</td>
            <td colspan="2" class="td-center">4</td>
            <td colspan="2" class="td-center">5(4-2)</td>
            <td colspan="2" class="td-center">6(4-3)</td>
          </tr>
          <tr>
            <td class="td-center">1</td>
            <td colspan="3" class="td-center" style="width: 120px">一、加速折旧、摊销（不含一次性扣除，1.1+1.2+…）</td>
            <td style="width: 50px"><a href="javascript:void(0);" class="btn btn-sm">增加</a></td>
            <td style="width: 50px"><a href="javascript:void(0);" class="btn btn-sm">删除</a></td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v1x1.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v1x2.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v1x3.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v1x4.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v1x5.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v1x6.value) }}</td>
          </tr>
          <!-- <tr> v2x1 数组 </tr> -->
          <tr>
            <td class="td-center">2</td>
            <td colspan="3" class="td-center">二、一次性扣除（2.1+2.2+…）</td>
            <td><a href="javascript:void(0)" class="btn btn-sm">增加</a></td>
            <td><a href="javascript:void(0)" class="btn btn-sm">删除</a></td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v3x1.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v3x2.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v3x3.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v3x4.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v3x5.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v3x6.value) }}</td>
          </tr>
          <!-- <tr> v4x1 数组 </tr> -->
          <tr>
            <td colspan="6" class="td-center">合计（1+2）</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v5x1.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v5x2.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v5x3.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v5x4.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v5x5.value) }}</td>
            <td colspan="2" class="td-center">{{ parseFloatNum(data.v5x6.value) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../../reportTaxStaticConfig.js";
import taxQue from "../../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

function watchStart() {
  watch(data, (newVal, oldVal) => {}, {
    deep: true,
    immediate: true,
  });
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1050px !important;
}
</style>

<script>
const tableHtml = `
<table class="">
  <colgroup>
    <col width="50" />
    <col />
  </colgroup>
  <tbody>
    <tr>
      <td rowspan="3" class="td-center">行次</td>
      <td colspan="5" rowspan="3" class="td-center">项目</td>
      <td colspan="2" rowspan="2" class="td-center">本年享受优惠的资产原值</td>
      <td colspan="10" class="td-center">本年累计折旧\摊销（扣除）金额</td>
    </tr>
    <tr>
      <td colspan="2" class="td-center">账载折旧\摊销金额</td>
      <td colspan="2" class="td-center">按照税收一般规定计算的折旧\摊销金额</td>
      <td colspan="2" class="td-center">享受加速政策计算的折旧\摊销金额</td>
      <td colspan="2" class="td-center">纳税调减金额</td>
      <td colspan="2" class="td-center">享受加速政策优惠金额</td>
    </tr>
    <tr>
      <td colspan="2" class="td-center">1</td>
      <td colspan="2" class="td-center">2</td>
      <td colspan="2" class="td-center">3</td>
      <td colspan="2" class="td-center">4</td>
      <td colspan="2" class="td-center">5(4-2)</td>
      <td colspan="2" class="td-center">6(4-3)</td>
    </tr>
    <tr>
      <td class="td-center">1</td>
      <td colspan="3" class="td-center">一、加速折旧、摊销（不含一次性扣除，1.1+1.2+…）</td>
      <td><a href="javascript:void(0);" class="btn btn-sm">增加</a></td>
      <td><a href="javascript:void(0);" class="btn btn-sm">删除</a></td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="td-center">2</td>
      <td colspan="3" class="td-center">二、一次性扣除（2.1+2.2+…）</td>
      <td><a href="javascript:void(0)" class="btn btn-sm">增加</a></td>
      <td><a href="javascript:void(0)" class="btn btn-sm">删除</a></td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td colspan="6" class="td-center">合计（1+2）</td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td colspan="2" class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text" autocomplete="off" \/>/g, '<el-input-number v-model.trim="defaultValueNum" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValueNum = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
